import { AxInit, ModuleName } from "../../Lib/AxSystem/AxInit";

@ModuleName("MaintenanceScriptInfo")
export class MaintenanceScriptInfo implements AxInit
{
    AxInit(init): void {
        this.CheckScript();
    }

    CheckScript() {
        AxessViewer.loadPartialView('/Home/CheckMaintenanceMode',
            {},
            (x: IMaintenanceScriptInfo) => {
                if (!x.running) {
                    location.reload();
                    return;
                }
                const progess = x.toRun - x.open;
                const percentDone = Math.round(100 / x.toRun * progess);

                $('.maintenanceScript__progress').html(progess.toString());
                $('.maintenanceScript__progressBar .ax-progressbar__progress').css('width', `${percentDone}%`);

                setTimeout(() => {
                        this.CheckScript();
                },
                3000);
            },
            {});
    }
}

interface IMaintenanceScriptInfo {
    running: boolean;
    open: number;
    toRun: number;
}